import { render } from "./BlogDrivingSalesHoliday.vue?vue&type=template&id=22808593"
import script from "./BlogDrivingSalesHoliday.vue?vue&type=script&lang=js"
export * from "./BlogDrivingSalesHoliday.vue?vue&type=script&lang=js"

import "./BlogDrivingSalesHoliday.vue?vue&type=style&index=0&id=22808593&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__